import withData from './with-data';
import withSwapiService from './with-swapi-service';
import compose from './compose';
import withChildFunction from './with-child-function';

export {
  withData,
  withSwapiService,
  compose,
  withChildFunction
};



// WEBPACK FOOTER //
// ./src/components/hoc-helpers/index.js